module.exports = __webpack_public_path__ + "c05631bec3391f7e4044357549a6aeab.png";